export const tradesReportAllLocation = "/reports/alltrades"